import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { borderedVariant, capsuleVariant, compactVariant, filledVariant, underlineVariant, type VariantColorType, type VariantSizeType, type VariantType } from './variant-styles';
import type { ComponentProps, ElementType } from 'react';
type GenericChipProps<E extends ElementType> = {
  as?: E;
  children: React.ReactNode;
  variant: VariantType;
  color: VariantColorType;
  size?: VariantSizeType;
} & ComponentProps<E>;
function getVariantClassesByVariant(variant: VariantType, color: VariantColorType, size: VariantSizeType): string {
  switch (variant) {
    case 'filled':
      return filledVariant({
        size,
        color
      });
    case 'bordered':
      return borderedVariant({
        size,
        color
      });
    case 'compact':
      return compactVariant({
        size,
        color
      });
    case 'underline':
      return underlineVariant({
        size,
        color
      });
    case 'capsule':
      return capsuleVariant({
        size,
        color
      });
  }
}
function GenericChip(t0) {
  const $ = _c(18);
  let children;
  let className;
  let color;
  let props;
  let t1;
  let t2;
  let variant;
  if ($[0] !== t0) {
    ({
      as: t1,
      children,
      variant,
      color,
      size: t2,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = color;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
    $[7] = variant;
  } else {
    children = $[1];
    className = $[2];
    color = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
    variant = $[7];
  }
  const Element = t1 === undefined ? "div" : t1;
  const size = t2 === undefined ? "default" : t2;
  let t3;
  if ($[8] !== className || $[9] !== color || $[10] !== size || $[11] !== variant) {
    t3 = cn("inline-flex w-fit items-center whitespace-nowrap", getVariantClassesByVariant(variant, color, size), className);
    $[8] = className;
    $[9] = color;
    $[10] = size;
    $[11] = variant;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== Element || $[14] !== children || $[15] !== props || $[16] !== t3) {
    t4 = <Element className={t3} {...props}>{children}</Element>;
    $[13] = Element;
    $[14] = children;
    $[15] = props;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
export { GenericChip };